import { z } from "zod";
export const BOOKING_SOURCES = ["owner", "self_service"];
export const bookingSourceSchema = z.enum(BOOKING_SOURCES);
export const BookingSourceEnum = {
    OWNER: "owner",
    SELF_SERVICE: "self_service",
};
